<template>
  <div>
    <nav id="sp_nav" class="drawer-nav">
      <div
        class="drawer-menu"
        style="
          transition-timing-function: cubic-bezier(0.1, 0.57, 0.1, 1);
          transition-duration: 0ms;
          transform: translate(0px, 0px) translateZ(0px);
        "
      >
        <dl class="user">
          <dt>ユーザー機能</dt>
          <dd class="sp-drawer-fav">
            <a :href="favoriteLink">お気に入り</a>
          </dd>
          <dd class="sp-drawer-history">
            <a :href="historyLink">閲覧履歴</a>
          </dd>
          <dd class="mypage">
            <a href="//my.tabikobo.com">
              マイページ
              <span>（ご予約のお客様向け）</span>
            </a>
          </dd>
        </dl>
        <dl class="world">
          <dt><a href="/">海外旅行</a></dt>
          <dd><a href="/area/">取り扱いエリア一覧</a></dd>
          <dd><a href="/outlet/">厳選ツアー</a></dd>
          <dd><a href="/special/hitori/#listArea">一人旅</a></dd>
          <dd><a href="/special/">特集</a></dd>
          <dd><a href="/special/#round">2，3都市周遊</a></dd>
          <dd><a href="/special/#hotel">ホテルにこだわる</a></dd>
          <dd><a href="/special/#season">季節の休暇に</a></dd>
          <dd><a href="/special/#airlines">航空会社から選ぶ</a></dd>
        </dl>
        <dl class="service">
          <dt>旅行サービス</dt>
          <dd>
            <a href="/parts/">Wi-Fi・保険・その他</a>
          </dd>
        </dl>
        <dl class="corporate">
          <dt>法人</dt>
          <dd class="last">
            <a href="/corporate/">出張・団体</a>
          </dd>
        </dl>
        <dl class="contents_menu">
          <dt>旅工房について</dt>
          <dd>
            <a href="https://faq.tabikobo.com/?site_domain=default">よくある質問</a>
          </dd>
          <dd>
            <a href="/magazine/">メルマガ登録</a>
          </dd>
        </dl>
      </div>
    </nav>
    <button
      id="menuBtn"
      type="button"
      class="drawer-toggle drawer-hamburger"
      @click="show = !show"
    >
      <span class="sr-only">toggle navigation</span>
      <span class="drawer-hamburger-icon"></span>
    </button>
    <div class="drawer-overlay drawer-toggle" @click="show = !show"></div>
  </div>
</template>

<script>
export default {
  name: 'TheDrawer',
  props: {
    japanGiving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
    }
  },
  // TODO お気に入り・履歴が全て置き換わった後にこの処理は削除すること
  computed: {
    historyLink() {
      return this.japanGiving ? '/japan/tour/history/' : '/tour/history/'
    },
    favoriteLink() {
      return this.japanGiving ? '/japan/tour/favorite/' : '/tour/favorite/'
    },
  },
  watch: {
    show(show) {
      if (!document.body.classList.contains('drawer')) {
        document.body.classList.add('drawer')
      }
      document.body.classList.toggle('drawer-open', show)
      document.body.classList.toggle('drawer-close', !show)
    },
  },
}
</script>
